// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { CancelIn } from './cancelIn.zod.ts';

export const FeedbackCancelApiFeedbackItemIdCancelPostBody = zod.union([CancelIn,zod.null()])

export type FeedbackCancelApiFeedbackItemIdCancelPostBody = zod.input<typeof FeedbackCancelApiFeedbackItemIdCancelPostBody>;
export type FeedbackCancelApiFeedbackItemIdCancelPostBodyOutput = zod.output<typeof FeedbackCancelApiFeedbackItemIdCancelPostBody>;
